import LxcCommon from '@lxc/app-device-common'
import ElementPlus from 'element-plus'
import { createPinia } from "pinia";
import { createApp } from 'vue'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import { clickOutside } from './directives/clickOutside.directive'
import App from '~/App.vue'
import { LxcDragNDrop } from './plugins/lxcDragNDrop'
import { router } from '~/plugins/router'
import '~/assets/styles/vendors/element-plus.scss'
import '~/assets/styles/main/main.scss'
import acl from '~/plugins/acl'
import { i18n, fallbackLocaleTag } from '~/plugins/i18n'

// Import Tailwind Elements plugin
import 'tw-elements'

// Import Tailwind CSS
import '@lxc/css/main.css'
import '@lxc/css/fonts/Montserrat/webfonts/Montserrat.css';

// Import common CSS
import '@lxc/app-device-common/dist/assets/index.css'

// Import ack CSS to reapply element-plus styles, to remove when element-plus will be removed
import '~/assets/styles/ack-element-plus.scss'

// Import dragula styles
import 'dragula/dist/dragula.css'

const app = createApp(App)

app.directive('click-outside', clickOutside)

dayjs.extend(localeData)
dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.locale(fallbackLocaleTag)

app.use(createPinia())
app.use(LxcCommon)
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.use(acl)
app.use(LxcDragNDrop)

app.mount('#app')
